import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert, { AlertProps, Color } from '@material-ui/lab/Alert';
import { useState, forwardRef, useImperativeHandle, Ref } from "react";

export interface ToastProps {
  showMessage: (msg: string, type: Color) => void;
}

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const Toast = forwardRef((props, ref: Ref<ToastProps>) => {

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [type, setType] = useState<Color>("info");

  const handleClose = (event: React.SyntheticEvent) => {
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    showMessage: (msg: string, type: Color) => {
      setMessage(msg);
      setType(type);
      setOpen(true);
    },
  }));

  return (
    <Snackbar
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={open}
      autoHideDuration={4000}
    >
      <Alert severity={type}>{message}</Alert>
    </Snackbar>
  );
});
